import { live } from '../clients/proto';
export interface ClientCallbackConfig {
  onOpen?: () => void;
  onFail?: (code: number, message: string, extra?: any) => void;
  onClose?: (code: number, message: string, extra?: any) => void;
  onReceivedMsg?: (broadcastMsg: live.BroadcastMsg) => void;
}
export default class ClientCallback {
  onOpen?: () => void;
  onFail?: (code: number, message: string, extra?: any) => void;
  onClose?: (code: number, message: string, extra?: any) => void;
  onReceivedMsg?: (broadcastMsg: live.BroadcastMsg) => void;

  constructor(config: ClientCallbackConfig) {
    const { onOpen, onFail, onClose, onReceivedMsg } = config;
    this.onOpen = onOpen;
    this.onFail = onFail;
    this.onClose = onClose;
    this.onReceivedMsg = onReceivedMsg;
  }

  onOpenCallback() {
    this.onOpen && this.onOpen();
  }

  onFailCallback(code: number, message: string, extra?: any) {
    this.onFail && this.onFail(code, message, extra);
  }

  onCloseCallback(code: number, message: string, extra?: any) {
    this.onClose && this.onClose(code, message, extra);
  }

  onReceivedMsgCallback(broadcastMsg: live.BroadcastMsg) {
    this.onReceivedMsg && this.onReceivedMsg(broadcastMsg);
  }

  setReceiveMsgCallback(callback: (broadcastMsg) => void) {
    this.onReceivedMsg = callback;
  }
}
